import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Layout from "../../../Components/Layout";
import EventsList from "../../../Components/User/Events/EventsList";
import { EventLanguage } from "../../../utils/Languages";

const EventListPage = () => {
  const [eventsFilter, EventsFilterModal] = useState(false);
  const { userDetails } = useSelector((state) => state.user);
  const isOrganizer = userDetails?.userType === "organizer";

  const changeModalState = () => {
    EventsFilterModal(!eventsFilter);
  };

  return (
    <Layout
      activeMenuId="event-list"
      extraElement={
        <div className="event-main-actions">
          <button className="event-action-btn" type="button" onClick={changeModalState} aria-label="Filter events">
            <i className="bi bi-funnel" aria-hidden="true"></i>
            <span>{EventLanguage.UserEvents.list.ButtonHeading}</span>
          </button>
          {isOrganizer && (
            <Link className="event-action-btn is-primary" to="/myEvents/create/basic_info" aria-label="Create event">
              <i className="bi bi-calendar-plus" aria-hidden="true"></i>
              <span>Create</span>
            </Link>
          )}
        </div>
      }
    >
      <EventsList eventsFilter={eventsFilter} CloseModalHandler={changeModalState} />
    </Layout>
  );
};

export default EventListPage;
